import React from 'react'
import { number, string, element, oneOfType } from 'prop-types'

import { switchProp, ifNotProp } from 'styled-tools'
import { Alert } from '@creditas/icons'
import { styled } from '@creditas/stylitas'

const Wrapper = styled.div`
  padding: 16px 0;
  width: 100%;

  ${ifNotProp(
    'hasProgressBar',
    switchProp('level', {
      info: 'border-left: 8px solid #4499ee;',
      error: 'border-left: 8px solid #dd2222;',
    }),
  )}
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 62px auto;

  > div {
    align-self: center;
  }
`

const IconArea = styled.div`
  padding-left: 8px;
`

const MessageArea = styled.div`
  padding: 0 22.5px;
  border-left: 1px solid #eeeeee;
`

function getLevelIcon(level) {
  switch (level) {
    case 'error':
      return <Alert.AlertTriangle fontSize="large" color="#dd2222" />
    case 'info':
    default:
      return <Alert.Info fontSize="large" color="#4499ee" />
  }
}

const MessageWrapper = ({ autoClose = null, children, level = 'info' }) => (
  <Wrapper hasProgressBar={autoClose !== null} level={level}>
    <Grid>
      <IconArea>{getLevelIcon(level)}</IconArea>
      <MessageArea>{children}</MessageArea>
    </Grid>
  </Wrapper>
)

MessageWrapper.propTypes = {
  autoClose: number,
  children: oneOfType([string, element]),
  level: string,
}

export { MessageWrapper }
